var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-drha-patient.99ce6a04.png","uri@2x": __webpack_public_path__ + "icon-drha-patient.de078656.png","uri@3x": __webpack_public_path__ + "icon-drha-patient.2db96b7c.png",
    width: 27,
    height: 32
});